import { FC, Fragment, useState } from 'react';

import AutTable from '../../../blocks/aut-grid-table';
import RiskAssessmentItem from '../../../forms/custom-pcnl/riskAssessmentItem';
import RiskAssessmentItemEdit from '../../../forms/custom-pcnl/riskAssessmentItemEdit';

import { getPCNLRiskAssementColumns } from '../../../../utils/data';
import { PCNLRiskAssessmentItem } from '../../../../utils/models';
import { matchPhrases } from '../../../../utils/utilities';
import toastService from '../../../../services/toastService';

interface Props {
	riskAssessmentItems: PCNLRiskAssessmentItem[];
	onDataChange: (items: PCNLRiskAssessmentItem[]) => void;
}

const PCNLRiskAssessment: FC<Props> = (props) => {
	const [itemToEdit, setItemToEdit] = useState<PCNLRiskAssessmentItem | null>(null);

	const handleAddItem = (item: PCNLRiskAssessmentItem) => {
		const matchFound = props.riskAssessmentItems.find((riskItem) => matchPhrases(riskItem.structuralMember, item.structuralMember));
		if (matchFound) return toastService.error('Record for ' + item.structuralMember + ' already exists');
		
		props.onDataChange([...props.riskAssessmentItems, item]);
	};

	const handleDeleteItem = (item: PCNLRiskAssessmentItem): void => {
		const newAnomalyItems = props.riskAssessmentItems.filter((i) => i.structuralMember !== item.structuralMember);
		props.onDataChange(newAnomalyItems);
	};

	const handleEditItem = (item: PCNLRiskAssessmentItem): void => {
        const updatedItems = props.riskAssessmentItems.map((risk) => risk.structuralMember === itemToEdit?.structuralMember ? item : risk);

		props.onDataChange(updatedItems);
		setItemToEdit(null);
	};

	const handleCancelEdit = (): void => {
		setItemToEdit(null);
	};

	return (
		<Fragment>
			{itemToEdit ? (
				<RiskAssessmentItemEdit
					initialData={itemToEdit}
					onEdit={handleEditItem}
					onCancelEdit={handleCancelEdit}
				/>
			) : (
				<RiskAssessmentItem onAdd={handleAddItem} />
			)}

			<div className="divider my-4"></div>

			<AutTable
				onItemsReset={props.onDataChange}
				data={props.riskAssessmentItems}
				tableColumns={getPCNLRiskAssementColumns()}
				onDeleteItem={handleDeleteItem}
				onEditItem={(item: PCNLRiskAssessmentItem) => setItemToEdit(item)}
			/>
		</Fragment>
	);
};

export default PCNLRiskAssessment;
